import React from 'react'
import {Link} from 'react-router-dom'

class Logo extends React.Component {




  render () {

    if(window.location.pathname==='/'){
      return  null;
    }else{
      return <Link className="logo" to="/"></Link>
    }
  }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/modules/misc/Logo.js